import IconAlert from './IconAlert';

export default IconAlert;
